import { render, staticRenderFns } from "./extra-category-videos.vue?vue&type=template&id=3d2203c0&scoped=true&lang=pug&"
import script from "./extra-category-videos.vue?vue&type=script&lang=js&"
export * from "./extra-category-videos.vue?vue&type=script&lang=js&"
import style0 from "./extra-category-videos.vue?vue&type=style&index=0&id=3d2203c0&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d2203c0",
  null
  
)

export default component.exports